const Style = {

  onboarding: 'flex items-center justify-center bg-gradient-to-b from-brand-400 to-blue-500 min-h-full text-left'

}

export default Style;